export class RestoreBigQueryNativePitrRequest {
    'restoreAccountId';
    'destination';
    'restoreToTime';
    'selectedTables';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "BigQueryNativePitrDestination",
            "format": ""
        },
        {
            "name": "restoreToTime",
            "baseName": "restoreToTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "selectedTables",
            "baseName": "selectedTables",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreBigQueryNativePitrRequest.attributeTypeMap;
    }
    constructor() {
    }
}
